export default __webpack_public_path__ + "static/media/glyphs-no-2.43be76d9.mid";